export default class KeyNumber {
  constructor(element) {
    this.element = element;
    this.slides = [...this.element.querySelectorAll('.js-key-number-slide')];
    this.triggers = [...this.element.querySelectorAll('.js-key-number-trigger')];
    this.toggle = this.element.querySelector('.js-key-number-toggle');
    this.duration = Number.parseInt(this.element.dataset.duration, 10) || 5000;
    this.activeIndex = 0;
    this.interval = null;
    this.isPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  mount() {
    if (this.slides.length < 2) {
      this.toggle?.setAttribute('hidden', '');
      return;
    }

    this.slides.forEach((slide) => slide.removeAttribute('hidden'));
    this.setActive(0);

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.setActive(Number.parseInt(trigger.dataset.index, 10));
        this.restart();
      });
    });

    this.toggle.addEventListener('click', () => {
      this.isPaused = !this.isPaused;
      this.updateToggle();

      if (this.isPaused) {
        this.stop();
      } else {
        this.start();
      }
    });

    this.element.addEventListener('mouseenter', () => this.stop());
    this.element.addEventListener('mouseleave', () => this.start());
    this.element.addEventListener('focusin', () => this.stop());
    this.element.addEventListener('focusout', () => this.start());

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    });

    this.updateToggle();
    this.start();
  }

  setActive(index) {
    this.activeIndex = index;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      slide.toggleAttribute('inert', !isActive);
    });

    this.triggers.forEach((trigger, triggerIndex) => {
      const isActive = triggerIndex === index;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  start() {
    if (this.isPaused || this.interval || document.hidden) {
      return;
    }

    this.interval = window.setInterval(() => {
      this.setActive((this.activeIndex + 1) % this.slides.length);
    }, this.duration);
  }

  stop() {
    if (!this.interval) {
      return;
    }

    window.clearInterval(this.interval);
    this.interval = null;
  }

  restart() {
    this.stop();
    this.start();
  }

  updateToggle() {
    const label = this.isPaused
      ? this.toggle.dataset.resumeLabel
      : this.toggle.dataset.pauseLabel;

    this.toggle.classList.toggle('is-paused', this.isPaused);
    this.toggle.setAttribute('aria-label', label);
    this.toggle.setAttribute('aria-pressed', this.isPaused ? 'true' : 'false');
  }
}
